import { useQueryClient } from '@tanstack/react-query'

import { refreshRequestViews } from '@/features/hr/hr-actions'
import { useRecordVersion } from '@/lib/form/use-record-version'
import { queryKeys } from '@/lib/query-keys'
import { hrApi, type HrRequestDetail } from '@/services/http/hr'

/**
 * Yeniden gönderme formunun sürüm kapısı. Form açılışta talepten kopyalanan bir taslaktır (panel
 * `updated_at` değişince baştan kurulur), bu yüzden sürüm o anki talebin sürümüne sabitlenir
 * (`dirty: true`). "Yeniden yükle" talebi tazeler; talep değişmişse panel yeni `updated_at`
 * anahtarıyla yeniden doğar ve taslağı güncel talepten kurar.
 */
export function useResubmitVersion(request: HrRequestDetail) {
  const queryClient = useQueryClient()
  return useRecordVersion({
    recordId: request.id,
    loaded: request.version,
    dirty: true,
    reload: async () => {
      const fresh = await queryClient.fetchQuery({
        queryKey: queryKeys.hr.request(request.id),
        queryFn: () => hrApi.request(request.id),
        staleTime: 0,
      })
      refreshRequestViews(queryClient, fresh)
    },
  })
}
